/* eslint-disable react/no-danger, import/prefer-default-export */
import React from 'react';

export const ClipPathSvgs = () => (
  <svg
    width="0"
    height="0"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className="sr-only"
  >
    <defs>
      <clipPath
        id="footer-foreground-mobile"
        clipPathUnits="objectBoundingBox"
      >
        <path d="M0.281,0.001 C0.242,0,0.205,0.006,0.183,0.016 L0,0.107 V1 h1 V0.017 L0.281,0.001" />
      </clipPath>

      <clipPath
        id="footer-foreground-tablet"
        clipPathUnits="objectBoundingBox"
      >
        <path d="M0.133,0.002 C0.113,0,0.094,0.012,0.083,0.033 L0,0.191 V1 h1 V0.076 L0.133,0.002" />
      </clipPath>

      <clipPath
        id="footer-foreground-desktop"
        clipPathUnits="objectBoundingBox"
      >
        <path d="M0.139,0.001 c-0.012,-0.002,-0.023,0.011,-0.029,0.033 L0,0.407 V1 h1 V0.133 L0.139,0.001" />
      </clipPath>

      <clipPath
        id="footer-background-mobile"
        clipPathUnits="objectBoundingBox"
      >
        <path d="M0.127,0.013 c-0.039,0.001,-0.074,0.008,-0.092,0.02 L0,0.055 V1 h1 V0 L0.127,0.013" />
      </clipPath>

      <clipPath
        id="footer-background-tablet"
        clipPathUnits="objectBoundingBox"
      >
        <path d="M0.057,0.019 c-0.02,0,-0.038,0.015,-0.048,0.038 L0,0.079 V1 H1 V0.001 L0.057,0.019" />
      </clipPath>

      <clipPath
        id="footer-background-desktop"
        clipPathUnits="objectBoundingBox"
      >
        <path d="M0.1,0.001 c-0.012,0,-0.022,0.014,-0.028,0.038 L0,0.325 V1 h0.999 l0.001,-0.962 L0.1,0.001" />
      </clipPath>
    </defs>
  </svg>
);
